import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { UnitsModel } from '../models/UnitsModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class UnitsService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getUnits(unCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("unCode", unCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<UnitsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Units/Getunits',options);
    }

    public AddUnit(units: UnitsModel) {
        return this.http.post<UnitsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Units/AddUnits', units);
    }
    public delUnits(unCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("unCode", unCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<UnitsModel>(this.urlsconfig.WebAPIURL_Test + 'api/Units/Deleteunits',options);
    }

    public getUnitsLookup(unCode: string, unName: string, compCode: string) {
      let params = new HttpParams();
      params = params.append("unCode", unCode);
      params = params.append("unName", unName);
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<UnitsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Units/UnitsLookup', options);
  }

  public getUnitsLookupTop(compCode: string) {
      let params = new HttpParams();
      params = params.append("compCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<UnitsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Units/UnitsLookupTop', options);
  }
 
}
